import axios from 'axios'
import router from '../router'

let axiosConfig = {
  // baseURL: window.$baseUrl === undefined ? 'http://192.168.5.208:8080' : window.$baseUrl
  // baseURL: window.$baseUrl === undefined ? 'http://xmhgapi.com/shipTest' : window.$baseUrl
  baseURL: window.$baseUrl === undefined ? 'http://xmhgapi.com/ship' : window.$baseUrl
}

let server = axios.create(axiosConfig)
let once = false


function getUrl () {
  return axiosConfig.baseURL
}


/**
 * 注入token
 * */
// 添加请求拦截器
server.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem("Authorization");
  config.headers = {
    // "Content-Type": "application/json;charset=utf-8",
  }
  if (token) {
    config.headers['Authorization'] = token
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// token失效 207错误码的处理
server.interceptors.response.use(function (response) {
  const res = response.data
  if (res.code === 207) {
    let msg = '登录状态失效，请重新登录'
    return Promise.reject(msg)
  }
  once = false
  return response
})

function handleResCode (vm, err) {
  console.log('err: ', err)
  once = true
  vm.$message.warning(err)
  let token = window.localStorage.getItem("Authorization")
  if (token) {
    window.localStorage.removeItem("Authorization")
  }
  if (err !== '登录状态失效，请重新登录') return
  router.push('/')
}

// 发送Post数据
function Post (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let url = type

  server.post(url, param)
    .then((res) => {
      //  服务器响应数据在这里面
      // window.console.log('Post: ', res.data)
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch((err) => {
      // token失效 207错误码的处理
      if (vm.$message && !once) {
        handleResCode(vm, err)
        return
      }
      if (fn === null || fn === undefined) {
        return
      }
      // fn.call(vm, null)
    })
}

// 发送Get数据
function Get (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let url = type

  server.get(url, param)
    .then((res) => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, res.data)
    })
    .catch((err) => {
      // token失效 207错误码的处理
      if (vm.$message && !once) {
        handleResCode(vm, err)
        return
      }
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

// 发送Put数据
function Put (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let config = {
    params: param
  }

  let url = '/api/' + type

  server.put(url, config)
    .then((res) => {
      //  服务器响应数据在这里面
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch((err) => {
      // token失效 207错误码的处理
      if (vm.$message && !once) {
        handleResCode(vm, err)
        return
      }
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

// 发送Delete数据
function Delete (type, msg) {
  // 要发送的数据
  let param = msg.data
  // 接收返回的回调函数
  let fn = msg.fn
  // 回调函数运行的this指针
  let vm = msg.vm

  let config = {
    data: {
      params: param
    }
  }
  let url = '/api/' + type

  server.delete(url, config)
    .then((res) => {
      //  服务器响应数据在这里面
      let resdata = res.data
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, resdata)
    })
    .catch(() => {
      if (fn === null || fn === undefined) {
        return
      }
      fn.call(vm, null)
    })
}

export {
  server,
  Get,
  Post,
  Put,
  Delete,
  getUrl
}
